export function createNoiseBuffer(context: BaseAudioContext, durationSeconds = 1): AudioBuffer {
  const frameCount = Math.max(1, Math.floor(context.sampleRate * durationSeconds));
  const buffer = context.createBuffer(1, frameCount, context.sampleRate);
  const data = buffer.getChannelData(0);

  for (let index = 0; index < frameCount; index += 1) {
    data[index] = Math.random() * 2 - 1;
  }

  return buffer;
}

export function createNoiseSource(context: BaseAudioContext, durationSeconds = 1): AudioBufferSourceNode {
  const source = context.createBufferSource();
  source.buffer = createNoiseBuffer(context, durationSeconds);

  return source;
}

export function createFilteredNoise(
  context: BaseAudioContext,
  frequency: number,
  q = 0.8,
  durationSeconds = 1
): { source: AudioBufferSourceNode; filter: BiquadFilterNode } {
  const source = createNoiseSource(context, durationSeconds);
  const filter = context.createBiquadFilter();
  filter.type = "bandpass";
  filter.frequency.value = frequency;
  filter.Q.value = q;
  source.connect(filter);

  return { source, filter };
}
